import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from "reactstrap";

function ListadoDestinosCompra() {
  const { user } = useContext(AuthContext);
  const URL = process.env.REACT_APP_URL_DESTINOS_COMPRA;
  const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [destinos, setDestinos] = useState([]);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [selectedNombre, setSelectedNombre] = useState("");
  const [selectedDesc, setSelectedDesc] = useState("");

  const toggle = () => setModal(!modal);
  const toggleEdit = () => setEditModal(!editModal);

  useEffect(() => {
    axios.get(URL, auth)
      .then((res) => setDestinos(res.data))
      .catch((err) => console.log(err));
  }, []);

  function crear(e) {
    e.preventDefault();
    axios.post(URL, { nombre, descripcion }, auth)
      .then((res) => {
        setDestinos([...destinos, res.data]);
        setNombre(""); setDescripcion("");
        toggle();
        Swal.fire({ icon: "success", title: "Creado", timer: 1200, showConfirmButton: false });
      })
      .catch((err) => { console.log(err); Swal.fire("Error", "No se pudo crear", "error"); });
  }

  function abrirEditar(d) {
    setSelectedId(d._id);
    setSelectedNombre(d.nombre);
    setSelectedDesc(d.descripcion || "");
    toggleEdit();
  }

  function guardarEdicion(e) {
    e.preventDefault();
    axios.patch(`${URL}/${selectedId}`, { nombre: selectedNombre, descripcion: selectedDesc }, auth)
      .then((res) => {
        setDestinos(destinos.map(d => d._id === selectedId ? res.data : d));
        toggleEdit();
        Swal.fire({ icon: "success", title: "Actualizado", timer: 1200, showConfirmButton: false });
      })
      .catch((err) => { console.log(err); Swal.fire("Error", "No se pudo actualizar", "error"); });
  }

  function eliminar(id) {
    Swal.fire({ title: "¿Eliminar destino?", icon: "warning", showCancelButton: true, confirmButtonText: "Sí, eliminar" })
      .then((result) => {
        if (result.isConfirmed) {
          axios.patch(`${URL}/${id}`, { is_active: "No" }, auth)
            .then(() => {
              setDestinos(destinos.filter(d => d._id !== id));
              Swal.fire({ icon: "success", title: "Eliminado", timer: 1200, showConfirmButton: false });
            })
            .catch(() => Swal.fire("Error", "No se pudo eliminar", "error"));
        }
      });
  }

  return (
    <>
      <Header />
      <br /><br />
      {user.menu_oc ? (
        <div className="card container col-10">
          <Row className="mt-3 mb-3">
            <Col>
              <h4>Destinos de Compra</h4>
              <p className="text-muted" style={{ fontSize: "0.85rem" }}>
                Catálogo de destinos (almacenes intermedios, puertos, bodegas) a donde llegan los pedidos de OC.
              </p>
            </Col>
            <Col className="text-end">
              <Button color="success" size="sm" onClick={toggle}>
                <i className="fas fa-plus" /> Nuevo Destino
              </Button>
            </Col>
          </Row>

          <Table size="sm" bordered striped responsive>
            <thead className="thead-light">
              <tr>
                <th>#</th>
                <th>Nombre</th>
                <th>Descripción</th>
                <th style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {destinos.map((d, i) => (
                <tr key={d._id}>
                  <td className="align-middle">{i + 1}</td>
                  <td className="align-middle"><strong>{d.nombre}</strong></td>
                  <td className="align-middle">{d.descripcion || "—"}</td>
                  <td className="text-center align-middle">
                    <Button size="sm" color="info" onClick={() => abrirEditar(d)}>
                      <i className="fas fa-edit" />
                    </Button>{" "}
                    <Button size="sm" color="danger" onClick={() => eliminar(d._id)}>
                      <i className="fas fa-trash" />
                    </Button>
                  </td>
                </tr>
              ))}
              {destinos.length === 0 && (
                <tr><td colSpan={4} className="text-center text-muted">Sin destinos registrados</td></tr>
              )}
            </tbody>
          </Table>

          {/* Modal Crear */}
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>Nuevo Destino</ModalHeader>
            <Form onSubmit={crear}>
              <ModalBody>
                <FormGroup>
                  <Label>Nombre *</Label>
                  <Input type="text" value={nombre} onChange={e => setNombre(e.target.value)} required placeholder="Ej. Laredo, Dallas, Houston..." />
                </FormGroup>
                <FormGroup>
                  <Label>Descripción</Label>
                  <Input type="text" value={descripcion} onChange={e => setDescripcion(e.target.value)} placeholder="Descripción opcional" />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="success" type="submit">Guardar</Button>{" "}
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
              </ModalFooter>
            </Form>
          </Modal>

          {/* Modal Editar */}
          <Modal isOpen={editModal} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>Editar Destino</ModalHeader>
            <Form onSubmit={guardarEdicion}>
              <ModalBody>
                <FormGroup>
                  <Label>Nombre *</Label>
                  <Input type="text" value={selectedNombre} onChange={e => setSelectedNombre(e.target.value)} required />
                </FormGroup>
                <FormGroup>
                  <Label>Descripción</Label>
                  <Input type="text" value={selectedDesc} onChange={e => setSelectedDesc(e.target.value)} />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="success" type="submit">Guardar</Button>{" "}
                <Button color="secondary" onClick={toggleEdit}>Cancelar</Button>
              </ModalFooter>
            </Form>
          </Modal>

          <br />
        </div>
      ) : <p className="text-muted ms-3">Sin acceso.</p>}
    </>
  );
}

export default ListadoDestinosCompra;
